import classnames from "classnames";
import { number, string, bool, node } from "prop-types";

export const SPINNER_SIZES = {
  XS: "xs",
  SMALL: "small",
  MEDIUM: "medium",
  BIG: "big",
};

const sizeMap = {
  [SPINNER_SIZES.XS]: { wrapper: "w-5 h-5", border: "border-2" },
  [SPINNER_SIZES.SMALL]: { wrapper: "w-8 h-8", border: "border-2" },
  [SPINNER_SIZES.MEDIUM]: { wrapper: "w-10 h-10", border: "border-[3px]" },
  [SPINNER_SIZES.BIG]: { wrapper: "w-12 h-12", border: "border-[3px]" },
};

const Spinner = ({ isLoad, children, marginTop, size }) => {
  if (!isLoad) return children;

  const marginTopProperty = typeof marginTop === "number" ? `mt-${marginTop}` : "";
  const { wrapper, border } = sizeMap[size] || sizeMap[SPINNER_SIZES.BIG];

  const wrapClass = classnames({
    "w-full flex justify-center": true,
    "h-full items-center": !marginTop,
    [marginTopProperty]: !!marginTopProperty,
  });

  const spinnerClass = classnames(
    wrapper,
    border,
    "rounded-full border-border border-t-accent-blue animate-spin"
  );

  return (
    <div className={wrapClass}>
      <div className={spinnerClass} role="status" aria-label="Loading" />
    </div>
  );
};

Spinner.propTypes = {
  isLoad: bool,
  children: node,
  marginTop: number,
  size: string,
};

Spinner.defaultProps = {
  isLoad: false,
  size: SPINNER_SIZES.BIG,
};

export default Spinner;
